var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28739_238531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28739_238531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.6924C11.0375 11.6924 10.2136 11.3497 9.52825 10.6644C8.84275 9.97888 8.5 9.15488 8.5 8.19238C8.5 7.22988 8.84275 6.40597 9.52825 5.72063C10.2136 5.03513 11.0375 4.69238 12 4.69238C12.9625 4.69238 13.7864 5.03513 14.4718 5.72063C15.1573 6.40597 15.5 7.22988 15.5 8.19238C15.5 9.15488 15.1573 9.97888 14.4718 10.6644C13.7864 11.3497 12.9625 11.6924 12 11.6924ZM4.5 19.3079V17.0846C4.5 16.595 4.633 16.1415 4.899 15.7241C5.165 15.3068 5.5205 14.986 5.9655 14.7616C6.95383 14.2771 7.95092 13.9137 8.95675 13.6714C9.96258 13.429 10.977 13.3079 12 13.3079C13.023 13.3079 14.0374 13.429 15.0433 13.6714C16.0491 13.9137 17.0462 14.2771 18.0345 14.7616C18.4795 14.986 18.835 15.3068 19.101 15.7241C19.367 16.1415 19.5 16.595 19.5 17.0846V19.3079H4.5ZM6 17.8079H18V17.0846C18 16.8821 17.9413 16.6946 17.824 16.5221C17.7067 16.3498 17.5474 16.2091 17.3462 16.1001C16.4846 15.6758 15.6061 15.3543 14.7107 15.1356C13.8152 14.9171 12.9117 14.8079 12 14.8079C11.0883 14.8079 10.1848 14.9171 9.28925 15.1356C8.39392 15.3543 7.51542 15.6758 6.65375 16.1001C6.45258 16.2091 6.29333 16.3498 6.176 16.5221C6.05867 16.6946 6 16.8821 6 17.0846V17.8079ZM12 10.1924C12.55 10.1924 13.0208 9.99655 13.4125 9.60488C13.8042 9.21322 14 8.74238 14 8.19238C14 7.64238 13.8042 7.17155 13.4125 6.77988C13.0208 6.38822 12.55 6.19238 12 6.19238C11.45 6.19238 10.9792 6.38822 10.5875 6.77988C10.1958 7.17155 10 7.64238 10 8.19238C10 8.74238 10.1958 9.21322 10.5875 9.60488C10.9792 9.99655 11.45 10.1924 12 10.1924Z",
    fill: "#ECF3F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.7f8e691cc8c1312949687e7880ef3316.svg";
export { ForwardRef as ReactComponent };